import React from "react"

import {FieldViewGroupProps} from "../../../../render/group/@type"
import UserIcon from "../../../../../gd-components/icons/user/user"

// const debug = "FieldUser_ViewGroup"
const debug = false

export default function FieldUser_ViewGroup(props: FieldViewGroupProps) {

    const value = props.field.getViewValue(props.model)

    const user = gd.session.users.get(value)

    debug && console.log(debug, 'render', value, user)

    const classes = Classes("flex-row-left-center ui5-txt-less-important ui5-txt-bold", props.className)

    return (
        <div className={classes}>
            {props.showGroupIcon !== false &&
                <div className="flex-row-center-center flex-no-shrink size-22">
                    <UserIcon
                        className   = "no-shadow"
                        size        = "22"
                        userId      = {user?.id || 'none'}
                    />
                </div>
            }
            <div className="max-w-100-percent txt-truncate view-group-label">{props.field.groupLabel(value, props.groupBy) || props.field.placeholder}</div>
        </div>
    )
}



